import styled, { keyframes } from 'styled-components'
import RouterLink from 'components/sharedComponents/RouterLink'
import {
  TextHeadline3 as BuiTextHeadline3,
  TextBody as BuiTextBody,
  IconInfo as BuiIconInfo,
  TextCallout2 as BuiTextCallout2,
  IconAttach as BuiIconAttach,
  TextCallout1,
  Modal,
  Divider as BuiDivider,
  Link,
  Label,
  colors,
} from '@blocket/blocket-ui'
import { mediaQueries } from 'plugins/device'

/* Channel */

export const InfoContainer = styled.div`
  max-height: 230px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 96px auto 0;
`

/* Channel AdInfo */

export const BankIdVerifiedLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
`

export const ProfileInfoWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const BadgesWrapper = styled.div`
  display: flex;
  margin-right: 16px;
`

export const Badge = styled.div`
  display: flex;
  align-items: center;
  margin-right: 12px;

  &:last-child {
    margin-right: 0px;
  }
`

export const OnlineIndicator = styled.div`
  margin-right: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${colors.green400};
`

export const OnlineStatusWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const InfoWrapper = styled.div`
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  z-index: 1;
`

export const RecipientLink = styled(RouterLink)`
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  hyphens: auto;
  &:hover {
    color: ${colors.grey800};
    text-decoration: underline;
  }
`

export const BackArrow = styled(Link)`
  display: flex;
  color: ${colors.black100};
`

export const ImageWrapper = styled.div`
  position: relative;
  align-self: center;
  height: 40px;
  width: 40px;
  flex-shrink: 0;
  ${({ fade }) => fade && 'opacity: 0.6;'}
`

export const UserInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  height: 62px;
`

export const RecipientWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 2;
  align-items: flex-start;
  margin-left: 20px;

  @media ${mediaQueries.medium} {
    margin-left: 0;
  }
`

export const AdInfoWrapper = styled.div`
  display: flex;
  justify-content: ${({ isMobile }) => (isMobile ? 'space-between' : 'flex-start')};
  padding: 16px;
  width: 100%;
`

export const AdIssueWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const AdIssueLabelWrapper = styled(AdIssueWrapper)`
  flex-direction: row;
`

export const AdIssueLabel = styled(Label)`
  max-height: 20px;
  margin-left: 8px;
  @media ${mediaQueries.medium} {
    margin-left: 10px;
  }
`

export const PriceText = styled(TextCallout1)`
  color: ${colors.black100};
  margin-left: 8px;
  font-weight: 500;
  @media ${mediaQueries.medium} {
    margin-left: 10px;
  }
`

export const AdInfoLinkWrap = styled(Link)`
  display: flex;
  flex-direction: row;
  line-height: 0;
`

export const InfoText = styled.div`
  text-align: left;
  margin: 0 8px;
  color: ${({ adIssueText }) => (adIssueText ? colors.grey700 : colors.black700)};
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  @media ${mediaQueries.medium} {
    margin: 0 10px;
  }
`

export const AdInfoText = styled(InfoText)`
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  hyphens: auto;
`

export const ActionButton = styled.button`
  display: flex;
  cursor: pointer;
`

export const TextHeadline3 = styled(BuiTextHeadline3)`
  padding-top: 48px;
`

export const TextBody = styled(BuiTextBody)`
  padding-top: 8px;
`

export const Divider = styled(BuiDivider)`
  height: 1px;
  background-color: ${colors.grey200};
`

/* Channel View */

export const WarningModal = styled(Modal)`
  /* prevent default behavior of Modal to expand over the screen, up to "medium" */
  @media (max-width: 767px) {
    max-width: 550px;
    height: auto;
    bottom: 0;
    top: initial;
    left: 50%;
    transform: translate(-50%);
    border-radius: 10px 10px 0 0;
  }
  @media ${mediaQueries.medium} {
    width: auto;
    border-radius: 4px;
  }
`

export const MessageWarningLink = styled(Link)`
  width: fit-content;
  padding: 8px;
  margin-bottom: 16px;
  display: flex;
  background: ${colors.blue50};
  border-radius: 6px;
  cursor: pointer;
  @media ${mediaQueries.medium} {
    align-items: center;
  }
`

export const MessageWarningBoxText = styled.p`
  margin-left: 10px;
  font-size: 12px;
  line-height: 20px;
  color: ${colors.black100};
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${({ innerHeight }) => innerHeight && `height: ${innerHeight}px`};
`

export const ListWrapper = styled.div`
  height: 100%;
  position: relative;
  overflow: hidden;
`

export const List = styled.ul`
  height: 100%;
  list-style: none;
  display: flex;
  flex-direction: column;
  overflow: auto;
  overflow-y: ${({ preventYScroll }) => (preventYScroll ? 'hidden' : 'auto')};
  overflow-x: hidden; /* firefox fix */
  padding: 0 16px;
  padding-bottom: ${({ removePaddingBottom }) => (removePaddingBottom ? 0 : '30px')};
  -webkit-overflow-scrolling: touch;
`

export const TopListInfo = styled.li`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  margin-bottom: 24px;
`

export const ListItem = styled.li`
  max-width: ${(props) => (props.isMobile ? '75%' : '50%')};
  width: ${(props) => (props.isImage ? '75%' : 'auto')};
  align-self: ${(props) => (props.isMe || props.isUploading ? 'flex-end' : 'flex-start')};
  margin-bottom: ${(props) => (props.containsExternalContactInfo ? '8px;' : '16px')};
  flex: 0 0 auto;
  &:last-of-type {
    margin-bottom: 0px;
  }
`

export const ImgPlaceholder = styled.div`
  padding-bottom: ${(props) => props.aspectRatio}%;
  position: relative;
  border-radius: ${(props) => (props.isMe ? '20px 20px 0' : '20px 20px 20px 0')};
  overflow: hidden;
  cursor: pointer;
`

export const ChatImage = styled.img`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

export const ChatBubbleWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ChatBubble = styled.div`
  padding: 8px 16px;
  background-color: ${(props) => (props.isMe ? colors.blue800 : colors.grey200)};
  border-radius: ${(props) => (props.isMe ? '20px 20px 0' : '20px 20px 20px 0')};
`

export const ChatBubbleIcon = styled.div`
  display: flex;
  margin-left: 8px;
  min-width: 20px;
  min-height: 20px;
`

export const ChatText = styled(BuiTextBody)`
  color: ${(props) => (props.isMe ? colors.white100 : colors.black100)};
  white-space: pre-wrap;
  word-break: break-word;
  word-wrap: break-word; /* IE11, Firefox */
`

export const ChatFileLink = styled.a`
  display: flex;
  align-items: center;
`

export const IconAttach = styled(BuiIconAttach)`
  color: ${colors.black100};
  padding-right: 10px;
  width: 50px;
`

export const IconAttachMe = styled(IconAttach)`
  color: ${colors.white100};
`

export const MetaData = styled.div`
  font-size: 11px;
  color: grey;
  text-align: ${(props) => (props.isMe ? 'right' : 'left')};
  &:last-child {
    margin-top: 8px;
  }
`

export const MapLink = styled.a`
  color: ${(props) => (props.isMe ? colors.white100 : colors.blue600)};
  text-decoration: underline;
`

export const TimeIndicator = styled(MetaData)`
  margin-bottom: 8px;
`

export const TypingIndicator = styled.li`
  min-height: 24px;
  position: sticky;
  padding-top: 6px;
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: baseline;
  bottom: 65px;
  font-size: 11px;
  color: grey;
  background: ${(props) => (props.typing ? colors.white100 : 'transparent')};
  text-align: left;
  bottom: 0;
  left: 0;
  p {
    margin-right: 4px;
  }
`

const BlinkAnimation = keyframes`
  0% {
    opacity: .2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .2;
  }
`

export const DotIndicator = styled.span`
  height: 4px;
  width: 4px;
  margin: 0px 1px;
  background-color: #4d4d4e;
  border-radius: 50%;
  animation-name: ${BlinkAnimation};
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }

  &:nth-child(4) {
    animation-delay: 0.6s;
  }
`

export const SpinnerWrapper = styled.li`
  height: 80px;
  flex: 0 0 auto;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ImgTextWrapper = styled(ProfileInfoWrapper)`
  margin-top: 8px;
`

export const ImageSpinnerWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  height: auto;
  transform: translate(-50%, -50%);
  z-index: 1;
  background-color: transparent;
`

/* Channel Gdpr Message */

export const GdprMessageWrapper = styled.div`
  flex: 0 0 auto;
  padding: 16px;
  border-bottom: 1px solid ${colors.grey200};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  word-break: break-word;
`

export const UnderlineLink = styled(Link)`
  text-decoration: underline;
  font-size: 15px;
`

/* Channel Tip Message */

export const TipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.blue50};
  border-radius: 4px;
  padding: 16px;
  margin: 16px 0;
`

export const TipTitle = styled(TextCallout1)`
  margin-bottom: 4px;
`

export const TipContent = styled(BuiTextCallout2)`
  margin-bottom: 4px;
  text-align: center;
`

/* Channel Info Message */

export const InfoMessageWrapper = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${colors.grey200};
  display: flex;
  justify-content: center;
  align-items: center;
  word-break: break-word;
`

export const IconInfo = styled(BuiIconInfo)`
  margin-right: 10px;
  color: ${colors.grey700};
`

export const TextCallout2 = styled(BuiTextCallout2)`
  color: ${colors.grey700};
`
